import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import data from "../data/products.json";

const Projects = () => {
  return (
    <div className="padding text-text1 bg-bg1  ">
      {data.map((list) => (
        <List
          title={list.title}
          id={list.id}
          about={list.about}
          technologies={list.technologies}
          git={list.git}
          website={list.website}
          year={list.year}
          src={list.src}
          border={list.end}
          mobileScreen={list.mobileScreen}
        />
      ))}
    </div>
  );
};

const List = ({ title, id, about, technologies, git, website, year, src, border, mobileScreen }) => {
  const mobileWidth = window.screen.width <= 428;
  const [hoverState, setHoverState] = useState(false);

  return (
    <motion.div
      initial={{ y: 0, opacity: 1 }}
      animation={{ opacity: 0, y: -1000 }}
      transition={{ duration: 2 }}
      onHoverStart={() => setHoverState(true)}
      onHoverEnd={() => setHoverState(false)}
      //if it phone device, uses click instead hover
      onClick={() => mobileWidth && setHoverState(!hoverState)}
      // if the count is last one make border at the bottom
      className={`border-text1 ${src === 6 ? "border-b pb-6" : ""}`}
      id={id}
    >
      <div className="flex justify-between px-2 font-electro">
        <div>00{src}</div> <div>{year}</div>
      </div>

      <div className="border-text1 text-text1 flex border-t sm:h-36 h-28 relative items-center ">
        <AnimatePresence>
          {hoverState && (
            <motion.div
              initial={{ y: -40, opacity: 1 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.3, ease: "circOut" }}
              exit={{ y: -40, opacity: 0 }}
              className="absolute flex w-full justify-around "
            >
              <div className="md:w-3/5 lg:w-1/2 font-prime">
                <div className={`font-lg  underline  mb-1 ${src === 6 ? "mt-4 sm:mt-0" : ""}`}>{title}</div>
                <div className="text-xs md:text-medium sm:tracking-tight tracking-tight leading-3 sm:leading-4    ">{about}</div>
              </div>
              <div className="flex flex-col relative padding space-y-1 font-advent  tracking-widest underline text-base  sm:text-lg  self-center">
                {git && (
                  <>
                    <a target="_blank" rel="noreferrer" href={`${git}`}>
                      Repo
                    </a>
                    <a target="_blank" rel="noreferrer" href={`${website}`}>
                      Live
                    </a>
                  </>
                )}
              </div>
            </motion.div>
          )}
        </AnimatePresence>
        {/* 
      "   back   In", "backOut", "backInOut"
            "anticipate" */}
        <AnimatePresence>
          {!hoverState && (
            <motion.div
              initial={{ y: 40, opacity: 1 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.3, ease: "backOut" }}
              exit={{ y: 40, opacity: 0 }}
              className="tracking-wide md:ml-16 md:text-7xl sm:text-5xl text-4xl absolute "
            >
              {title}
            </motion.div>
          )}
        </AnimatePresence>
      </div>
      {/* <div className="flex justify-between px-2 font-electro">
        <div>001</div> <div>2021</div>
      </div> */}
    </motion.div>
  );
};
export default Projects;
